import React from 'react';
import classNames from 'classnames';

const ContactNew = ({
    className,
    topOuterDivider,
    bottomOuterDivider,
    topDivider,
    bottomDivider,
    hasBgColor,
    invertColor,
    ...props
}) => {

    const outerClasses = classNames(
        'hero section center-content',
        topOuterDivider && 'has-top-divider',
        bottomOuterDivider && 'has-bottom-divider',
        hasBgColor && 'has-bg-color',
        invertColor && 'invert-color',
        className
    );

    const innerClasses = classNames(
        'hero-inner section-inner',
        topDivider && 'has-top-divider',
        bottomDivider && 'has-bottom-divider'
    );

    return (
        <section
            {...props}
            className={outerClasses}
        >
            <div className="container-sm">
                <div className={innerClasses}>
                    <div className="hero-content">
                        <h3 className="mt-30 mb-16" data-reveal-delay="200" style={{fontSize:'20px'}}>
                            contact@detasightmarketresearch.com <br /> <span className="text-color-primary">+91-7350029666</span>
                        </h3>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default ContactNew;